const _excluded = ["children", "hideBack", "hideStepper", "showLearnMoreModal", "stepperSteps", "activeStepIndex", "onStepClick", "completedSteps", "activeSteps"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import { DesktopPane } from "./DesktopPane/DesktopPane";
import { MobilePane } from "./MobilePane/MobilePane";
import { useResponsive } from "../../contexts";
import cn from 'classnames';
import styles from "./ClientFlowStructure.module.scss";
import { useCobConfig } from "../../clientOb/CobConfigContext";
export const ClientFlowStructure = _ref => {
  let {
    children,
    hideBack,
    hideStepper,
    showLearnMoreModal,
    stepperSteps,
    activeStepIndex,
    onStepClick,
    completedSteps,
    activeSteps
  } = _ref,
      rest = _objectWithoutProperties(_ref, _excluded);

  const {
    relationship
  } = useCobConfig();
  const vendorDetails = relationship.vendor;
  const {
    isMobile,
    isDesktop
  } = useResponsive();
  return /*#__PURE__*/React.createElement("div", {
    className: cn(styles.root, {
      [styles.mobile]: isMobile,
      [styles.desktop]: isDesktop
    })
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.paneContainer
  }, isMobile ? /*#__PURE__*/React.createElement(MobilePane, _extends({
    vendorDetails: vendorDetails,
    hideBack: hideBack,
    activeStepIndex: activeStepIndex,
    onBackClick: onStepClick
  }, rest)) : !hideStepper ? /*#__PURE__*/React.createElement(DesktopPane, _extends({
    showLearnMoreModal: showLearnMoreModal,
    stepperSteps: stepperSteps,
    completedSteps: completedSteps,
    activeSteps: activeSteps,
    activeStepIndex: activeStepIndex,
    onStepClick: onStepClick
  }, rest)) : null), /*#__PURE__*/React.createElement("div", {
    className: styles.stepsContainer
  }, children));
};